import { createWebHashHistory, createRouter } from "vue-router";
import Home from "../view/HomeView.vue";
import About from "../view/AboutView.vue";
import Daftar from "../view/EnrollView.vue";
import Absen from "../view/DetectionView.vue";
import Login from "../view/LoginView.vue";
import Cekout from "../view/CheckoutView.vue";
import Cekin from "../view/CheckinView.vue";
import Detail from "../view/DetailView.vue";
import Admin from "../view/AdminView.vue";
import KaryawanView from "../view/KaryawanView.vue";
import RegisterView from "@/view/RegisterView.vue";
import EditView from "@/view/EditView.vue";


const routes = [
  {
    path: "/",
    name: "Home",
    component: Home, meta: { requiresAuth: true }
  },
  {
    path: "/about",
    name: "About",
    component: About,
  },
    {
    path: "/daftar/:id",
    name: "Daftar",
    component: Daftar, meta: { requiresAuth: true }
  },
    {
    path: "/absen",
    name: "Absen",
    component: Absen, meta: { requiresAuth: true }
  },
  {
    path: "/cekout",
    name: "Cekout",
    component: Cekout, meta: { requiresAuth: true }
  },
    {
    path: "/cekin",
    name: "cekin",
    component: Cekin, meta: { requiresAuth: true }
  },
    {
    path: "/detail/:id",
    name: "detail",
    component: Detail, meta: { requiresAuth: true }
  },

  {
    path: "/admin",
    name: "admin",
    component: Admin, meta: { requiresAuth: true }
  },
  {
    path: "/list-karyawan",
    name: "list",
    component: KaryawanView, meta: { requiresAuth: true }
  },
  {
    path: "/register",
    name: "register",
    component: RegisterView, meta: { requiresAuth: true }
  },
  
  {
    path: "/edit/:id",
    name: "edit",
    component: EditView, meta: { requiresAuth: true }
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

// guard: cek auth
router.beforeEach((to, from, next) => {
  const isAuthenticated = !!localStorage.getItem("token");
  if (to.meta.requiresAuth && !isAuthenticated) {
    next("/login");
  } else {
    next();
  }
});

export default router;